import { useCallback, useState } from 'react';
import { useSearchParams } from 'react-router';

export const QUERY_SEARCH_PARAM_FILTER_GROUP = 'f_group';

export function useArticleListGroupFilter() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [availableGroupFilters, setAvailableGroupFilters] = useState<string[]>([]);

  const groupFilter = searchParams.get(QUERY_SEARCH_PARAM_FILTER_GROUP) ?? 'all';

  const setGroupFilter = useCallback(
    (value: string) => {
      setSearchParams(
        prev => {
          const newParams = new URLSearchParams(prev);
          if (value === 'all') {
            newParams.delete(QUERY_SEARCH_PARAM_FILTER_GROUP);
          } else {
            newParams.set(QUERY_SEARCH_PARAM_FILTER_GROUP, value);
          }
          return newParams;
        },
        { replace: true, preventScrollReset: true }
      );
    },
    [setSearchParams]
  );

  const updateAvailableGroupFilters = useCallback((groupFilters: string[]) => {
    setAvailableGroupFilters(groupFilters);
  }, []);

  const resetGroupFilter = useCallback(() => {
    setSearchParams(
      prev => {
        const newParams = new URLSearchParams(prev);
        newParams.delete(QUERY_SEARCH_PARAM_FILTER_GROUP);
        return newParams;
      },
      { replace: true, preventScrollReset: true }
    );
  }, [setSearchParams]);

  return {
    groupFilter,
    setGroupFilter,
    availableGroupFilters,
    updateAvailableGroupFilters,
    resetGroupFilter
  };
}
